import { Language } from '@/services/graphQL/api/generated/types_web';

import englishTranslations from '../../public/locales/en.json';
import frenchTranslations from '../../public/locales/fr.json';
import { Localization } from './localization';

const translation: { [key: string]: Localization } = {
  en: englishTranslations,
  fr: frenchTranslations,
};

export function getLocalization(localeKey: string = Language.En): Localization {
  const localeKeyLowercase = localeKey.toLocaleLowerCase();
  if (translation.hasOwnProperty(localeKeyLowercase)) {
    return translation[localeKeyLowercase] as Localization;
  } else {
    return translation['en'] as Localization;
  }
}

export function stringFromFormat(format: string, ...args: (string | number)[]): string {
  // Replace {0}, {1}, etc with content from args
  return format.replace(/{(\d+)}/g, (_, index) =>
    args[index] !== undefined ? String(args[index]) : `{${index}}`
  );
}

export function preventBreakingColon(text: string): string {
  return text.replace(/\s*:/g, '\u00A0:');
}

export function formatCodeUrlText(
  format: string,
  baseUrl: string
): { firstPart: string; lastPart: string } {
  const codeUrlWords = stringFromFormat(format, baseUrl).split(' ');
  return {
    firstPart: codeUrlWords.slice(0, 2).join(' '),
    lastPart: codeUrlWords
      .slice(2)
      .join(' ')
      .replace(/^https?:\/\//, ''),
  };
}
